import { render, staticRenderFns } from "./wine-glass.vue?vue&type=template&id=1697667d"
import script from "./wine-glass.vue?vue&type=script&lang=js"
export * from "./wine-glass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports